import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks"
import { collectionHeader } from "../index.js"

export default function CollectionHeader() {
    const containerRef = useRef(null);

    useEffect(() => {
        if(!collectionHeader || !containerRef.current) return;
        containerRef.current.appendChild(collectionHeader);
    }, [])

    return (
        <div ref={containerRef} />
    )
}
